import { useCallback, useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import EmailCollectionForm from './components/EmailCollectionForm';
import useImpressionTracking from '../../hooks/useImpressionTracking';

import type { EmailCollectionFormData } from './types';

type Props = {
  className?: string;
  descriptionText?: string;
  onSubmit?: (data: EmailCollectionFormData) => void;
  onView?: (impressionId: string) => void;
  submitText?: string;
  submitSuccessMessage?: string;
  variant?: 'inline' | 'modal';
};

function EmailCollection(props: Props) {
  const { onSubmit, onView } = props;

  const impressionId = useMemo(() => uuid(), []);

  const impressionRef = useImpressionTracking(() => {
    onView?.(impressionId);
  });

  const handleSubmit = useCallback(async (data: any) => onSubmit?.(data), [onSubmit]);

  return (
    <div ref={impressionRef}>
      <EmailCollectionForm {...props} onSubmit={handleSubmit} />
    </div>
  );
}

export default EmailCollection;
